package com.example.mystybag.common.logic

import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.input.TextFieldValue
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.common.model.TextInputBSVisualModel
import com.example.mystybag.common.model.TextInputBottomSheetUIState

class TextInputBottomSheetViewModel(
    context                 : AppContext,
    private val visualModel : TextInputBSVisualModel
): ChildViewModel<TextInputBottomSheetUIState>(
    context = context,
    uiData  = TextInputBottomSheetUIState(
        text            = TextFieldValue(text = visualModel.initialText, selection = TextRange(visualModel.initialText.length)),
        title           = visualModel.title,
        hint            = visualModel.hint,
        errorText       = visualModel.errorText,
        inputType       = visualModel.inputType,
        imageResource   = visualModel.imageResource,
        buttonText      = visualModel.buttonText,
        capitalization  = visualModel.capitalization,
        keyboardType    = visualModel.keyboardType,
        autoCorrect     = visualModel.autoCorrect,
        prefix          = visualModel.prefix,
        suffix          = visualModel.suffix,
        infoPromptText  = visualModel.infoPromptText
    )
) {
    override fun onResume() {
        updateState { it.copy(focusTextField = true) }
    }

    override fun onPause() {
        updateState { it.copy(focusTextField = false) }
    }

    fun onTextChanged(text: TextFieldValue) {
        updateState { state ->
            state.copy(text = text, isError = false)
        }
    }

    fun onIconClicked() {
        visualModel.onIconClick?.invoke()
    }

    fun onButtonClicked() {
        val validate = visualModel.validate?.invoke(uiState.value.text.text)
        if (validate?.first == true || (validate == null && uiState.value.text.text.isNotBlank()))
            visualModel.onTextChanged(uiState.value.text.text)
        else
            updateState { state ->
                state.copy(
                    isError     = true,
                    errorText   = validate?.second ?: uiState.value.errorText
                )
            }
    }
}